<template>
  <b-alert v-model="showAlert" variant='success' dismissible class="alert error-alert">
    {{ message }}
  </b-alert>
</template>

<style scoped>

.alert {
  position: fixed;
  bottom: 1%;
  z-index: 2000;
  left: 3%;
  right: 3%;
}

.error-alert {
  margin-top: 16px;
  color: #155724 !important;
  background-color: #d4edda !important;
  border-color: #a5bfab !important; /* #c3e6cb !important; */
}

</style>

<script>

import EventBus from '../EventBus';

export default {
  name: 'SuccessAlert',
  components: {},
  data () {
    return {
      message: '',
      showAlert: false
    };
  },
  computed: {},
  mounted () {
    EventBus.$on('show-success-alert', this.showSuccessAlert);
  },
  beforeDestroy () {
    EventBus.$off('show-success-alert', this.showSuccessAlert);
  },
  methods: {
    showSuccessAlert: function (message) {
      this.message = message;
      this.showAlert = true;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Modules/Alerts/SuccessAlert.vue